import TPowerSaving from '../../templates/powerSaving';

function PowerSaving() {
  return <TPowerSaving></TPowerSaving>;
}

export default PowerSaving;
